"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_TOKEN_MAX = exports.reportResolveInput = exports.reportListInput = exports.reportCreateInput = exports.listingMineInput = exports.listingListInput = exports.listingPublishInput = exports.LISTING_IMAGE_MAX_COUNT = exports.LISTING_IMAGE_URL_MAX = exports.listingPriceSchema = exports.LISTING_PRICE_STRING_MAX = exports.currencyCodeSchema = exports.REPORT_RESOLVE_ACTION_VALUES = exports.REPORT_STATUS_VALUES = exports.REPORT_TARGET_VALUES = exports.LISTING_SORT_VALUES = exports.TRADE_CURRENCY_VALUES = exports.LISTING_LANGUAGE_VALUES = exports.LISTING_CONDITION_VALUES = exports.LISTING_STATUS_VALUES = exports.LISTING_KIND_VALUES = exports.pageCursorPaginationInput = exports.forumRepliesListInput = exports.notificationMarkReadInput = exports.notificationListInput = exports.cursorPaginationInput = exports.CURSOR_MAX = exports.replyCreateInput = exports.topicSetPinnedInput = exports.topicUpdateInput = exports.topicCreateInput = exports.replyBodySchema = exports.topicBodySchema = exports.topicTitleSchema = exports.commentRepliesListInput = exports.CURSOR_PAGE_LIMIT_DEFAULT = exports.CURSOR_PAGE_LIMIT_MAX = exports.seriesCommentInput = exports.commentInput = exports.commentContentSchema = exports.changePasswordInput = exports.loginInput = exports.registerInput = exports.passwordSchema = exports.emailSchema = exports.EMAIL_MAX = exports.usernameSchema = exports.paginationSchema = exports.slugSchema = exports.RARITY_VALUES = void 0;
exports.COLLECTION_LIST_STATE_VALUES = exports.collectionUpsertInput = exports.collectionOwnedCountSchema = exports.COLLECTION_OWNED_COUNT_MAX = exports.COLLECTION_OWNED_COUNT_MIN = exports.adminAuditListInput = exports.AUDIT_ACTION_VALUES = exports.adminUserBanInput = exports.adminUsersListInput = exports.BAN_REASON_MAX = exports.ADMIN_USER_STATUS_VALUES = exports.adminCatalogImportInput = exports.adminCardDeleteInput = exports.adminSeriesDeleteInput = exports.optionalDeleteReason = exports.DELETE_REASON_MAX = exports.adminSubsetDeleteInput = exports.adminSubsetUpsertInput = exports.adminSubsetListInput = exports.adminCategoryDeleteInput = exports.adminCategoryUpsertInput = exports.adminCardUpsertInput = exports.cardBodyInput = exports.printRunInput = exports.parallelNameInput = exports.parallelOfSlugInput = exports.PRINT_RUN_MAX = exports.PRINT_RUN_MIN = exports.CARD_BODY_MAX = exports.PARALLEL_NAME_MAX = exports.adminSeriesUpsertInput = exports.cardsListBySeriesInput = exports.CARD_SERIES_LIST_QUERY_MAX = exports.CARD_SERIES_LIST_PAGE_MAX = exports.CARD_SERIES_LIST_PAGE_SIZE_MAX = exports.CARD_SERIES_LIST_PAGE_SIZE_DEFAULT = exports.CARD_SERIES_LIST_SORT_VALUES = exports.seriesListInput = exports.optionalReleaseDateInput = exports.optionalSlugOrEmpty = exports.releaseDateSchema = exports.SERIES_LIST_SORT_VALUES = exports.SUBSET_KIND_VALUES = exports.CARD_NUMBER_MAX = exports.adminAttributesSchema = exports.adminAttributeValueSchema = exports.ADMIN_ATTRIBUTE_VALUE_MAX = exports.ADMIN_ATTRIBUTE_KEY_MAX = exports.ADMIN_ATTRIBUTE_MAX_KEYS = exports.authTokenSchema = void 0;
exports.storedReleaseDate = exports.shanghaiYearMonth = exports.shanghaiMonthBounds = exports.shanghaiCivilDate = exports.releasesListInput = exports.releaseUpdateInput = exports.releaseGetByIdInput = exports.releaseDeleteInput = exports.releaseCreateInput = exports.parseShanghaiCivilDate = exports.adminReleasesListInput = exports.RELEASE_TITLE_MAX = exports.RELEASE_SOURCE_URL_MAX = exports.RELEASE_RANGE_MAX_DAYS = exports.RELEASE_NOTE_MAX = exports.RELEASE_LIST_LIMIT_MAX = exports.RELEASE_LIST_LIMIT_DEFAULT = exports.RELEASE_CURSOR_MAX = exports.utcCalendarDateFromInstant = exports.utcCalendarDate = exports.inclusiveUtcDayCount = exports.formatUtcCalendarDate = exports.adminMetricsInput = exports.METRICS_RANGE_MAX_DAYS = exports.collectionByCardInput = exports.collectionListInput = void 0;
exports.isBlankReplyContent = isBlankReplyContent;
const zod_1 = require("zod");
exports.RARITY_VALUES = ['common', 'rare', 'epic', 'legendary'];
exports.slugSchema = zod_1.z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'slug_format');
exports.paginationSchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(100).default(20),
});
// Identity primitives reused by web / native / miniapp clients so the
// "is this username allowed" rule lives in exactly one place. The regex
// allows letters, digits, underscores and hyphens — it is intentionally
// stricter than a slug so usernames stay readable in @mentions.
exports.usernameSchema = zod_1.z
    .string()
    .trim()
    .min(3, 'username_too_short')
    .max(24, 'username_too_long')
    .regex(/^[A-Za-z0-9_-]+$/, 'username_format');
/** Same cap as the login identifier, so a registered email can be used to sign in. */
exports.EMAIL_MAX = 128;
exports.emailSchema = zod_1.z
    .string()
    .trim()
    .max(exports.EMAIL_MAX, 'email_too_long')
    .toLowerCase()
    .email('email_format');
exports.passwordSchema = zod_1.z.string().min(8, 'password_too_short').max(128, 'password_too_long');
exports.registerInput = zod_1.z.object({
    email: exports.emailSchema,
    username: exports.usernameSchema,
    password: exports.passwordSchema,
});
exports.loginInput = zod_1.z.object({
    identifier: zod_1.z.string().trim().min(3, 'identifier_too_short').max(128, 'identifier_too_long'),
    password: exports.passwordSchema,
});
exports.changePasswordInput = zod_1.z.object({
    currentPassword: exports.passwordSchema,
    newPassword: exports.passwordSchema,
});
exports.commentContentSchema = zod_1.z
    .string()
    .trim()
    .min(1, 'comment_required')
    .max(500, 'comment_too_long');
exports.commentInput = zod_1.z.object({
    cardSlug: exports.slugSchema,
    content: exports.commentContentSchema,
    parentId: zod_1.z.string().uuid().optional(),
});
exports.seriesCommentInput = zod_1.z.object({
    seriesSlug: exports.slugSchema,
    content: exports.commentContentSchema,
    parentId: zod_1.z.string().uuid().optional(),
});
/** Shared cursor page size. Callers request the default; the API rejects a larger limit. */
exports.CURSOR_PAGE_LIMIT_MAX = 50;
exports.CURSOR_PAGE_LIMIT_DEFAULT = 20;
const cursorPageLimit = zod_1.z
    .number()
    .int()
    .min(1)
    .max(exports.CURSOR_PAGE_LIMIT_MAX)
    .default(exports.CURSOR_PAGE_LIMIT_DEFAULT);
exports.commentRepliesListInput = zod_1.z.object({
    parentId: zod_1.z.string().uuid(),
    cursor: zod_1.z.string().uuid().optional(),
    limit: cursorPageLimit,
    // When set, the page that contains this reply is returned and `cursor` is ignored.
    aroundId: zod_1.z.string().uuid().optional(),
});
/** Blank after trim, or only the prefilled `@username`, is not a reply. */
function isBlankReplyContent(content, prefillUsernames) {
    const trimmed = content.trim();
    if (!trimmed)
        return true;
    return prefillUsernames.some((name) => trimmed === `@${name}`);
}
// Forum (M6) — Markdown body capped at 10k chars to keep XSS surface
// (rehype-sanitize) and Postgres TOAST fast paths predictable.
exports.topicTitleSchema = zod_1.z
    .string()
    .trim()
    .min(1, 'title_required')
    .max(120, 'title_too_long');
exports.topicBodySchema = zod_1.z
    .string()
    .trim()
    .min(1, 'body_required')
    .max(10_000, 'body_too_long');
exports.replyBodySchema = zod_1.z
    .string()
    .trim()
    .min(1, 'reply_required')
    .max(5_000, 'reply_too_long');
exports.topicCreateInput = zod_1.z.object({
    title: exports.topicTitleSchema,
    body: exports.topicBodySchema,
});
exports.topicUpdateInput = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    title: exports.topicTitleSchema,
    body: exports.topicBodySchema,
});
exports.topicSetPinnedInput = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    pinned: zod_1.z.boolean(),
});
exports.replyCreateInput = zod_1.z.object({
    topicId: zod_1.z.string().uuid(),
    body: exports.replyBodySchema,
});
/**
 * List cursors are Prisma ids. Users, cards, listings, topics, and reports
 * all use `@default(uuid())`, which is 36 characters. Shorter test ids still fit.
 */
exports.CURSOR_MAX = 36;
const cursorSchema = zod_1.z.string().max(exports.CURSOR_MAX);
exports.cursorPaginationInput = zod_1.z.object({
    cursor: cursorSchema.optional(),
    limit: cursorPageLimit,
});
/** Own notifications, newest first. `limit` stays on the shared 1–50 cursor cap. */
exports.notificationListInput = exports.cursorPaginationInput;
exports.notificationMarkReadInput = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
/** Topic replies. `limit` is 1–50, default 20. `aroundId` selects the page that contains that reply. */
exports.forumRepliesListInput = exports.cursorPaginationInput.extend({
    topicId: zod_1.z.string().uuid(),
    aroundId: zod_1.z.string().uuid().optional(),
});
exports.pageCursorPaginationInput = zod_1.z.object({
    pageCursor: cursorSchema.optional(),
    cursor: cursorSchema.optional(),
    limit: cursorPageLimit,
});
// M7 — Trade listings + reports.
exports.LISTING_KIND_VALUES = ['SELL', 'BUY'];
exports.LISTING_STATUS_VALUES = ['OPEN', 'CLOSED'];
exports.LISTING_CONDITION_VALUES = [
    'NEAR_MINT',
    'LIGHTLY_PLAYED',
    'MODERATELY_PLAYED',
    'HEAVILY_PLAYED',
    'DAMAGED',
];
exports.LISTING_LANGUAGE_VALUES = ['ZH', 'EN', 'JA', 'OTHER'];
exports.TRADE_CURRENCY_VALUES = ['CNY', 'HKD', 'USD', 'JPY', 'EUR', 'TWD'];
exports.LISTING_SORT_VALUES = ['newest', 'price_asc', 'price_desc'];
exports.REPORT_TARGET_VALUES = ['LISTING', 'TOPIC', 'REPLY', 'COMMENT'];
exports.REPORT_STATUS_VALUES = ['PENDING', 'RESOLVED'];
exports.REPORT_RESOLVE_ACTION_VALUES = ['MARK_RESOLVED', 'REMOVE_TARGET'];
// ISO 4217 codes are exactly three uppercase letters. We don't enumerate the
// full set because cardhub's audience picks per-listing (CNY default with
// USD/JPY common second). The format check at least catches typos.
exports.currencyCodeSchema = zod_1.z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{3}$/, 'currency_format');
/**
 * Decimal(12, 2) prints in 13 characters (`9999999999.99`). 64 leaves room for
 * the leading zeros, extra fraction digits, and short scientific notation
 * (`1e2`) that the publish form accepts via `Number()`, without taking a
 * multi-kilobyte digit string.
 */
exports.LISTING_PRICE_STRING_MAX = 64;
exports.listingPriceSchema = zod_1.z
    .union([zod_1.z.number(), zod_1.z.string().max(exports.LISTING_PRICE_STRING_MAX)])
    .transform((val, ctx) => {
    const asNumber = typeof val === 'number' ? val : Number(val);
    if (!Number.isFinite(asNumber) || asNumber < 0 || asNumber > 9_999_999_999.99) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'price_range',
        });
        return zod_1.z.NEVER;
    }
    // Round to 2 decimals to match Decimal(12, 2) on the database side.
    return Math.round(asNumber * 100) / 100;
});
/** Same ceiling as the admin image fields. */
exports.LISTING_IMAGE_URL_MAX = 2048;
/** Publish form rejects a fifth photo before it calls the API. */
exports.LISTING_IMAGE_MAX_COUNT = 4;
exports.listingPublishInput = zod_1.z.object({
    cardSlug: exports.slugSchema,
    kind: zod_1.z.enum(exports.LISTING_KIND_VALUES),
    price: exports.listingPriceSchema.optional(),
    currency: exports.currencyCodeSchema.default('CNY'),
    // Cap at 4 to match the publish form ("每行一个 https 链接，最多 4 张").
    // Each URL matches the admin image fields and stays well under the 100kb body cap.
    imageUrls: zod_1.z
        .array(zod_1.z
        .string()
        .trim()
        .max(exports.LISTING_IMAGE_URL_MAX)
        .url('image_https')
        .refine((url) => url.toLowerCase().startsWith('https://'), {
        message: 'image_https',
    }))
        .max(exports.LISTING_IMAGE_MAX_COUNT, 'image_too_many')
        .default([]),
    contact: zod_1.z.string().trim().min(2, 'contact_too_short').max(200, 'contact_too_long'),
    note: zod_1.z.string().trim().max(500, 'note_too_long').optional(),
    condition: zod_1.z.enum(exports.LISTING_CONDITION_VALUES).optional(),
    language: zod_1.z.enum(exports.LISTING_LANGUAGE_VALUES).optional(),
    variantNote: zod_1.z.string().trim().max(40, 'variant_note_too_long').optional(),
});
exports.listingListInput = exports.cursorPaginationInput.extend({
    cardSlug: exports.slugSchema.optional(),
    kind: zod_1.z.enum(exports.LISTING_KIND_VALUES).optional(),
    condition: zod_1.z.enum(exports.LISTING_CONDITION_VALUES).optional(),
    language: zod_1.z.enum(exports.LISTING_LANGUAGE_VALUES).optional(),
    minPrice: exports.listingPriceSchema.optional(),
    maxPrice: exports.listingPriceSchema.optional(),
    currency: zod_1.z.enum(exports.TRADE_CURRENCY_VALUES).optional(),
    sort: zod_1.z.enum(exports.LISTING_SORT_VALUES).default('newest'),
});
exports.listingMineInput = exports.pageCursorPaginationInput.extend({
    cursor: cursorSchema.optional(),
});
exports.reportCreateInput = zod_1.z.object({
    targetType: zod_1.z.enum(exports.REPORT_TARGET_VALUES),
    targetId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().trim().min(4, 'reason_too_short').max(500, 'reason_too_long'),
});
exports.reportListInput = exports.cursorPaginationInput.extend({
    status: zod_1.z.enum(exports.REPORT_STATUS_VALUES).optional(),
});
exports.reportResolveInput = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    action: zod_1.z.enum(exports.REPORT_RESOLVE_ACTION_VALUES),
    resolution: zod_1.z.string().trim().max(500, 'resolution_too_long').optional(),
});
/**
 * Signed `{ sub, username }` JWTs are a few hundred characters. 2048 leaves
 * room for extra registered claims without accepting an arbitrary blob.
 */
exports.AUTH_TOKEN_MAX = 2048;
exports.authTokenSchema = zod_1.z.string().max(exports.AUTH_TOKEN_MAX);
const adminImageUrlSchema = zod_1.z
    .string()
    .trim()
    .max(exports.LISTING_IMAGE_URL_MAX)
    .refine((value) => value === '' || value.startsWith('https://') || value.startsWith('gradient:'), 'image_url')
    .optional();
/**
 * Seed attributes are a handful of short keys (`cost`, `type`, `随从`).
 * The editor does not set maxLength, so these caps stay wide, but 40 keys of
 * 64 and 500 characters stay under the 100kb JSON body cap even as CJK.
 */
exports.ADMIN_ATTRIBUTE_MAX_KEYS = 40;
exports.ADMIN_ATTRIBUTE_KEY_MAX = 64;
exports.ADMIN_ATTRIBUTE_VALUE_MAX = 500;
exports.adminAttributeValueSchema = zod_1.z.union([
    zod_1.z.string().max(exports.ADMIN_ATTRIBUTE_VALUE_MAX),
    zod_1.z.number(),
    zod_1.z.boolean(),
]);
exports.adminAttributesSchema = zod_1.z
    .record(zod_1.z.string().max(exports.ADMIN_ATTRIBUTE_KEY_MAX), exports.adminAttributeValueSchema)
    .refine((value) => Object.keys(value).length <= exports.ADMIN_ATTRIBUTE_MAX_KEYS, {
    message: 'attributes_too_many',
});
/** Printed card number. Empty string clears it. The grid renders a leading #. */
exports.CARD_NUMBER_MAX = 20;
exports.SUBSET_KIND_VALUES = ['BASE', 'INSERT'];
/** Omitted sort keeps the historical `createdAt` ascending order. */
exports.SERIES_LIST_SORT_VALUES = [
    'createdAtAsc',
    'createdAtDesc',
    'releaseDateAsc',
    'releaseDateDesc',
];
const RELEASE_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
/** Calendar date `YYYY-MM-DD`. Rejects impossible days such as 2024-02-31. */
exports.releaseDateSchema = zod_1.z
    .string()
    .trim()
    .superRefine((value, ctx) => {
    const match = RELEASE_DATE_PATTERN.exec(value);
    if (!match) {
        ctx.addIssue({ code: 'custom', message: 'invalid_date' });
        return;
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year ||
        date.getUTCMonth() !== month - 1 ||
        date.getUTCDate() !== day) {
        ctx.addIssue({ code: 'custom', message: 'invalid_date' });
    }
});
/** Empty string clears the value. Omitted leaves the stored value alone. */
exports.optionalSlugOrEmpty = zod_1.z.union([exports.slugSchema, zod_1.z.literal('')]).optional();
exports.optionalReleaseDateInput = zod_1.z.union([exports.releaseDateSchema, zod_1.z.literal('')]).optional();
const catalogSortOrderSchema = zod_1.z.number().int().min(-2_147_483_648).max(2_147_483_647);
exports.seriesListInput = exports.paginationSchema.extend({
    categorySlug: exports.slugSchema.optional(),
    year: zod_1.z.number().int().min(1).max(9999).optional(),
    sort: zod_1.z.enum(exports.SERIES_LIST_SORT_VALUES).optional(),
    /** Inclusive `YYYY-MM-DD` upper bound on `releaseDate`. Null dates do not match. */
    releasedOnOrBefore: exports.releaseDateSchema.optional(),
});
/** Checklist order. `number` compares the printed card number, not the slug. */
exports.CARD_SERIES_LIST_SORT_VALUES = ['number', 'name', 'rarity', 'created'];
exports.CARD_SERIES_LIST_PAGE_SIZE_DEFAULT = 60;
exports.CARD_SERIES_LIST_PAGE_SIZE_MAX = 100;
exports.CARD_SERIES_LIST_PAGE_MAX = 10_000;
exports.CARD_SERIES_LIST_QUERY_MAX = 200;
const cardsListBySeriesQuery = zod_1.z
    .string()
    .trim()
    .max(exports.CARD_SERIES_LIST_QUERY_MAX)
    .optional()
    .transform((value) => (value === undefined || value.length === 0 ? undefined : value));
/**
 * Page and page size stay JSON numbers. Unlike `series.list`, strings are
 * not coerced: a query-string number is an input error.
 */
exports.cardsListBySeriesInput = zod_1.z.object({
    seriesSlug: exports.slugSchema,
    q: cardsListBySeriesQuery,
    rarity: zod_1.z.enum(exports.RARITY_VALUES).optional(),
    subsetSlug: exports.slugSchema.optional(),
    sort: zod_1.z.enum(exports.CARD_SERIES_LIST_SORT_VALUES).default('number'),
    page: zod_1.z.number().int().min(1).max(exports.CARD_SERIES_LIST_PAGE_MAX).default(1),
    pageSize: zod_1.z
        .number()
        .int()
        .min(1)
        .max(exports.CARD_SERIES_LIST_PAGE_SIZE_MAX)
        .default(exports.CARD_SERIES_LIST_PAGE_SIZE_DEFAULT),
    /** Default false hides parallels. Omitted and false share one cache key. */
    includeParallels: zod_1.z.boolean().default(false),
});
exports.adminSeriesUpsertInput = zod_1.z.object({
    slug: exports.slugSchema,
    title: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().max(5000).optional(),
    coverUrl: adminImageUrlSchema,
    categorySlug: exports.optionalSlugOrEmpty,
    releaseDate: exports.optionalReleaseDateInput,
});
/** Parallel name after trim. Matches the admin form maxLength. */
exports.PARALLEL_NAME_MAX = 40;
/**
 * Markdown long description. Count is JavaScript characters after trim,
 * not bytes. Null and empty mean no long description.
 */
exports.CARD_BODY_MAX = 20_000;
/** Stored print-run total. Null means unnumbered. PostgreSQL INTEGER upper bound. */
exports.PRINT_RUN_MIN = 1;
exports.PRINT_RUN_MAX = 2_147_483_647;
/**
 * Empty string clears the link. Omitted leaves the stored link alone.
 * A non-empty value is a card slug.
 */
exports.parallelOfSlugInput = zod_1.z.union([exports.slugSchema, zod_1.z.literal('')]).optional();
/** Trimmed. Empty is allowed here; the write path rejects it when a base is set. */
exports.parallelNameInput = zod_1.z.string().trim().max(exports.PARALLEL_NAME_MAX).optional();
/**
 * JSON number or null. Strings are not coerced. Null clears the total.
 * Omitted leaves the stored value alone.
 */
exports.printRunInput = zod_1.z
    .number()
    .int()
    .min(exports.PRINT_RUN_MIN, 'print_run_min')
    .max(exports.PRINT_RUN_MAX)
    .nullable()
    .optional();
/**
 * Omitted leaves the stored value on update. Null clears it.
 * Empty after trim is stored as null by the write path.
 */
exports.cardBodyInput = zod_1.z
    .string()
    .trim()
    .max(exports.CARD_BODY_MAX, 'card_body_too_long')
    .nullable()
    .optional();
exports.adminCardUpsertInput = zod_1.z.object({
    slug: exports.slugSchema,
    name: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().max(5000).optional(),
    rarity: zod_1.z.enum(exports.RARITY_VALUES),
    imageUrl: adminImageUrlSchema,
    attributes: exports.adminAttributesSchema.default({}),
    seriesSlug: exports.slugSchema,
    cardNumber: zod_1.z.string().trim().max(exports.CARD_NUMBER_MAX).optional(),
    subsetSlug: exports.optionalSlugOrEmpty,
    parallelOfSlug: exports.parallelOfSlugInput,
    parallelName: exports.parallelNameInput,
    printRun: exports.printRunInput,
    body: exports.cardBodyInput,
});
exports.adminCategoryUpsertInput = zod_1.z.object({
    slug: exports.slugSchema,
    name: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().max(5000).optional(),
    sortOrder: catalogSortOrderSchema.default(0),
});
exports.adminCategoryDeleteInput = zod_1.z.object({
    slug: exports.slugSchema,
});
exports.adminSubsetListInput = zod_1.z.object({
    seriesSlug: exports.slugSchema,
});
exports.adminSubsetUpsertInput = zod_1.z.object({
    seriesSlug: exports.slugSchema,
    slug: exports.slugSchema,
    name: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().max(5000, 'description_too_long').optional(),
    kind: zod_1.z.enum(exports.SUBSET_KIND_VALUES),
    sortOrder: catalogSortOrderSchema.default(0),
});
exports.adminSubsetDeleteInput = zod_1.z.object({
    seriesSlug: exports.slugSchema,
    slug: exports.slugSchema,
});
/** Optional admin delete reason. Trimmed, then 0–500 characters. */
exports.DELETE_REASON_MAX = 500;
exports.optionalDeleteReason = zod_1.z
    .string()
    .trim()
    .max(exports.DELETE_REASON_MAX, { message: 'delete_reason_too_long' })
    .optional();
exports.adminSeriesDeleteInput = zod_1.z.object({
    slug: exports.slugSchema,
    force: zod_1.z.boolean().default(false),
    reason: exports.optionalDeleteReason,
});
exports.adminCardDeleteInput = zod_1.z.object({
    slug: exports.slugSchema,
    reason: exports.optionalDeleteReason,
});
exports.adminCatalogImportInput = zod_1.z.object({
    data: zod_1.z.unknown(),
    dryRun: zod_1.z.boolean().default(true),
});
exports.ADMIN_USER_STATUS_VALUES = ['active', 'banned'];
/** Ban and unban reasons are required after trim, and at most 500 characters. */
exports.BAN_REASON_MAX = 500;
exports.adminUsersListInput = zod_1.z.object({
    q: zod_1.z.string().trim().max(exports.EMAIL_MAX).optional(),
    status: zod_1.z.enum(exports.ADMIN_USER_STATUS_VALUES).optional(),
    cursor: cursorSchema.optional(),
    limit: cursorPageLimit,
});
exports.adminUserBanInput = zod_1.z.object({
    userId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().trim().min(1).max(exports.BAN_REASON_MAX),
});
exports.AUDIT_ACTION_VALUES = [
    'USER_BAN',
    'USER_UNBAN',
    'CONTENT_DELETE',
    'REPORT_RESOLVE',
];
exports.adminAuditListInput = zod_1.z.object({
    action: zod_1.z.enum(exports.AUDIT_ACTION_VALUES).optional(),
    user: zod_1.z.string().trim().min(1).max(24).optional(),
    cursor: cursorSchema.optional(),
    limit: zod_1.z.number().int().min(1).max(50).default(50),
});
/** Inclusive bounds for how many copies of one card a person can record. */
exports.COLLECTION_OWNED_COUNT_MIN = 0;
exports.COLLECTION_OWNED_COUNT_MAX = 99;
exports.collectionOwnedCountSchema = zod_1.z
    .number('collection_quantity')
    .int('collection_quantity')
    .min(exports.COLLECTION_OWNED_COUNT_MIN, 'collection_quantity')
    .max(exports.COLLECTION_OWNED_COUNT_MAX, 'collection_quantity');
exports.collectionUpsertInput = zod_1.z.object({
    cardSlug: exports.slugSchema,
    ownedCount: exports.collectionOwnedCountSchema,
    wanted: zod_1.z.boolean(),
});
/** `all` is every stored row. `owned` is ownedCount > 0. `wanted` is wanted. */
exports.COLLECTION_LIST_STATE_VALUES = ['all', 'owned', 'wanted'];
exports.collectionListInput = zod_1.z.object({
    cursor: zod_1.z.string().max(exports.CURSOR_MAX).optional(),
    limit: cursorPageLimit,
    state: zod_1.z.enum(exports.COLLECTION_LIST_STATE_VALUES).default('all'),
});
exports.collectionByCardInput = zod_1.z.object({
    cardSlug: exports.slugSchema,
});
var metrics_1 = require("./metrics");
Object.defineProperty(exports, "METRICS_RANGE_MAX_DAYS", { enumerable: true, get: function () { return metrics_1.METRICS_RANGE_MAX_DAYS; } });
Object.defineProperty(exports, "adminMetricsInput", { enumerable: true, get: function () { return metrics_1.adminMetricsInput; } });
Object.defineProperty(exports, "formatUtcCalendarDate", { enumerable: true, get: function () { return metrics_1.formatUtcCalendarDate; } });
Object.defineProperty(exports, "inclusiveUtcDayCount", { enumerable: true, get: function () { return metrics_1.inclusiveUtcDayCount; } });
Object.defineProperty(exports, "utcCalendarDate", { enumerable: true, get: function () { return metrics_1.utcCalendarDate; } });
Object.defineProperty(exports, "utcCalendarDateFromInstant", { enumerable: true, get: function () { return metrics_1.utcCalendarDateFromInstant; } });
var release_1 = require("./release");
Object.defineProperty(exports, "RELEASE_CURSOR_MAX", { enumerable: true, get: function () { return release_1.RELEASE_CURSOR_MAX; } });
Object.defineProperty(exports, "RELEASE_LIST_LIMIT_DEFAULT", { enumerable: true, get: function () { return release_1.RELEASE_LIST_LIMIT_DEFAULT; } });
Object.defineProperty(exports, "RELEASE_LIST_LIMIT_MAX", { enumerable: true, get: function () { return release_1.RELEASE_LIST_LIMIT_MAX; } });
Object.defineProperty(exports, "RELEASE_NOTE_MAX", { enumerable: true, get: function () { return release_1.RELEASE_NOTE_MAX; } });
Object.defineProperty(exports, "RELEASE_RANGE_MAX_DAYS", { enumerable: true, get: function () { return release_1.RELEASE_RANGE_MAX_DAYS; } });
Object.defineProperty(exports, "RELEASE_SOURCE_URL_MAX", { enumerable: true, get: function () { return release_1.RELEASE_SOURCE_URL_MAX; } });
Object.defineProperty(exports, "RELEASE_TITLE_MAX", { enumerable: true, get: function () { return release_1.RELEASE_TITLE_MAX; } });
Object.defineProperty(exports, "adminReleasesListInput", { enumerable: true, get: function () { return release_1.adminReleasesListInput; } });
Object.defineProperty(exports, "parseShanghaiCivilDate", { enumerable: true, get: function () { return release_1.parseShanghaiCivilDate; } });
Object.defineProperty(exports, "releaseCreateInput", { enumerable: true, get: function () { return release_1.releaseCreateInput; } });
Object.defineProperty(exports, "releaseDeleteInput", { enumerable: true, get: function () { return release_1.releaseDeleteInput; } });
Object.defineProperty(exports, "releaseGetByIdInput", { enumerable: true, get: function () { return release_1.releaseGetByIdInput; } });
Object.defineProperty(exports, "releaseUpdateInput", { enumerable: true, get: function () { return release_1.releaseUpdateInput; } });
Object.defineProperty(exports, "releasesListInput", { enumerable: true, get: function () { return release_1.releasesListInput; } });
Object.defineProperty(exports, "shanghaiCivilDate", { enumerable: true, get: function () { return release_1.shanghaiCivilDate; } });
Object.defineProperty(exports, "shanghaiMonthBounds", { enumerable: true, get: function () { return release_1.shanghaiMonthBounds; } });
Object.defineProperty(exports, "shanghaiYearMonth", { enumerable: true, get: function () { return release_1.shanghaiYearMonth; } });
Object.defineProperty(exports, "storedReleaseDate", { enumerable: true, get: function () { return release_1.storedReleaseDate; } });
//# sourceMappingURL=index.js.map